import { api } from 'common';

import { GetExternalDocumentPacketFormFields } from './FormFields';
import { GetExternalDocumentPacketDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

export const getExternalDocumentPacketConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'externalDocumentPacket',
  defaultConfig: {
    orderId: '',
  },
  configFields: {
    schema: api.FlowDefinition.GetExternalDocumentPacketBlockConfigSchema,
    FormFields: GetExternalDocumentPacketFormFields,
  },
  documentationMarkdown: GetExternalDocumentPacketDocumentation,
};
